export default __webpack_public_path__ + "static/media/ic_radioOn.a2de3380.svg";